import { CardComponents } from './CardComponents';
const json = [
    {
      "title": "Başlık 1",
      "description": "Açıklama 1"
    },
    {
      "title": "Başlık 2",
      "description": "Açıklama 2"
    },
    {
      "title": "Başlık 3",
      "description": "Açıklama 3"
    }
  ];
export const Projects = () => {
  return (CardComponents(json))
};
